"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export type SendingRecipient = string | string[] | {
//   include: string[]
//   exclude: string[]
// }
// export type SendingSchedule = {
//   delay: string | number | Date
//   until: string | number | Date
// }
// export type SendingOptions = {
//   return?: CreateSendingOptionReturnEnum
//   title?: string
// }
//# sourceMappingURL=Entity.js.map